import type { Control, FieldValues } from 'react-hook-form';
import OdinController from '../../dynamic-form/odin-controller.component';
import type { GeolocationValue } from './geolocation.component';
import Geolocation from './geolocation.component';
import type { DynamicFieldComponentProps } from '../../dynamic-form/dynamic-form.interfaces';

export interface HfGeolocationProps extends DynamicFieldComponentProps<GeolocationValue> {
  control: Control<FieldValues>;
  name: string;
}

export default function HfGeolocation({
  control,
  name,
  label,
  value,
  fieldValueConverter,
  labelStyles,
}: HfGeolocationProps) {
  return (
    <OdinController
      name={name}
      defaultValue={value}
      control={control}
      fieldValueConverter={fieldValueConverter}
      render={({ field: { value }, fieldState: { error } }) => {
        return <Geolocation name={name} label={label} value={value} error={error?.message} labelStyles={labelStyles} />;
      }}
    />
  );
}
